import client from "shared/setupClient";
import { loader } from "graphql.macro";

const removeChecklistMutation = loader("graphql/mutations/checklist/removeChecklist.graphql");

export default function removeChecklistAction(checklistId) {
    return () => client.mutate({
        mutation: removeChecklistMutation,
        variables: { checklistId }
    });
}
